<template>
  <div>
    <arRecap
      v-show="!showDetails"
      :show_age="true"
      :recap_data="units_with_outstanding_recap"
      :show_details="onShowDetails"
      :refresh_data="onRefreshData"
      search_type="UNPAID_EMPTY_UNITS"
    />
    <units_list v-show="showDetails" :hide_details="onHideDetails" search_type="UNPAID_EMPTY_UNITS" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import arRecap from "@/components/portal/global/UnitsSummary.vue";
import units_list from "@/components/portal/global/ContainerList.vue";
export default {
  name: "Outstanding",
  components: {
    arRecap,
    units_list,
  },
  created() {
    this.$store.dispatch("get_units_with_outstanding_recap");
  },
  data() {
    return {
      modalShow: false,
      showDetails : false,
    };
  },
  computed: {
    ...mapGetters(["units_with_outstanding_recap"]),
  },
  methods: {
    onHideDetails: function () {
      this.showDetails = false;
    },
    onShowDetails: function (carrier_code,consignee_code) {
      let payload = {
        carrier: carrier_code,
        client_id: consignee_code,
      };
      this.$store.dispatch("get_units_with_outstanding", payload).then(() => {
        this.showDetails = true;
      });
    },
    onRefreshData() {
      this.$store.dispatch("get_units_with_outstanding_recap");
    },
  },
};
</script>
